import { Paths, PathValue } from "@mctypes/global.types";
import React, { useEffect } from "react";
import { McInputNew, McTextAreaNew } from "../../../../../../../components";
import { Radio, Paper, Stack, Title } from "@mantine/core";import {  IGKRapport,
  IGKTemperaturmaalingResultater,
} from "../../../../../../../mc-shared/reportSchemas/gkReportSchema";
import ReportDocxImageContainer from "../../../../ReportBoard/ReportDocxImageContainer";
import { beregnetDiffMellomToVerdier } from "../../gkGlobalUtils";
const Temperaturmaaling: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKTemperaturmaalingResultater;
}> = ({ data, onUpdateEditData }) => {
  // const UTSTYRSOPTIONS = ["Termometer I", "Termometer II"];
  useEffect(() => {
    utdataBeregninger();
  }, [data.inndata.maaleresultat]);
  const utdataBeregninger = () => {
    const temperaturDiff = beregnetDiffMellomToVerdier(data.inndata.settpunktsTemp, data.inndata.maaleresultat);
    const utdata = {
      temperaturDiff: temperaturDiff,
    };
    onUpdateEditData("testResultater.temperaturmaaling.utdata", utdata);
  };
  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>Temperaturmåling</Title>
        <div className="d-flex flex-column mt-4">
          <McInputNew
            label={<>
              Fyll inn settpunktstemperaturen &#40;C<sup>o</sup>&#41;:
            </>}
            value={data.inndata.settpunktsTemp}
            normalizeNumbers={true}
            type="text"
            onBlur={(e) =>
              onUpdateEditData("testResultater.temperaturmaaling.inndata.settpunktsTemp", Number(e.target.value))
            }
            className="w-25"
          />
        </div>
        <div className="d-flex flex-column mt-4">
          <McInputNew
            label={<>
              Fyll inn målt stabil temperatur &#40;C<sup>o</sup>&#41;:
            </>}
            value={data.inndata.maaleresultat}
            normalizeNumbers={true}
            type="text"
            onBlur={(e) =>
              onUpdateEditData("testResultater.temperaturmaaling.inndata.maaleresultat", Number(e.target.value))
            }
            className="w-25"
          />
        </div>
        <div className="d-flex justify-content-between">
          <p className="mb-0">
            Temperaturdifferanse &#40;C<sup>o</sup>&#41; =
            <b>
              {" "}
              {beregnetDiffMellomToVerdier(data.inndata.settpunktsTemp, data.inndata.maaleresultat)?.toFixed(2) ?? ""}
            </b>
          </p>
          <p className="mb-0">Formel: &#40;Diff T = Tm - Ts&#41;</p>
        </div>
        <hr className="mt-0" />
        <div className="d-flex flex-column">
          <McInputNew
            label="Løpt tid til temperaturen er stabil (s):"
            value={data.inndata.tidTilTempErStabil}
            normalizeNumbers={true}
            type="text"
            onBlur={(e) =>
              onUpdateEditData("testResultater.temperaturmaaling.inndata.tidTilTempErStabil", Number(e.target.value))
            }
            className="w-25"
          />
        </div>
        <div className="d-flex flex-column mt-4">
          <div className="d-flex flex-column">
                        <Radio
              checked={data.inndata.godkjent === true}
              onChange={() => onUpdateEditData("testResultater.temperaturmaaling.inndata.godkjent", true)}
              label="Godkjent"
            />
                        <Radio
              checked={data.inndata.godkjent === false}
              onChange={() => onUpdateEditData("testResultater.temperaturmaaling.inndata.godkjent", false)}
              label="Ikke godkjent"
            />
          </div>
        </div>
        <div className="w-50 mt-4">
          <div>
            <ReportDocxImageContainer docxImageTag="temperaturmaaling" title="Målepunkter i rommet" />
          </div>
          <McTextAreaNew
            label="Kommentar:"
            value={data.inndata.kommentar}
            onChange={(e) => onUpdateEditData("testResultater.temperaturmaaling.inndata.kommentar", e.target.value)}
          />
        </div>
      </Stack>
    </Paper>
  );
};
export default Temperaturmaaling;